import * as classNames from "classNames";
import * as React from "react";
import { isSameDay, isDayDisabled } from "../utils/date";

export interface IDayProps extends React.Props<Day> {
    day: Date;
    endDate?: Date;
    excludeDates?: Date[];
    filterDate?: (d: Date) => boolean;
    maxDate?: Date;
    minDate?: Date;
    month?: number;
    onDayClick: (date: Date) => void;
    selected?: Date;
    startDate?: Date;
    notTabbable?: boolean;
}

export class Day extends React.Component<IDayProps, any> {
    constructor(props: IDayProps) {
        super(props);
    }

    public componentDidMount() {
        // document.getElementById("myBtn").addEventListener("click", () => {
        //     console.log("click on button");
        // });
    }

    public render(): JSX.Element {
        return (
            <button
                type="button"
                className={this.getClassNames()}
                onClick={() => this.handleClick()}
                disabled={this.isDisabled()}
                tabIndex={this.props.notTabbable ? -1 : 0}
                //aria-label={Globalize.format(this.props.day, Globalize.culture().calendars.standard.patterns.D)}
            >
                <span className="day">{this.props.day.getDate()}</span>
            </button>
        );
    }

    private handleClick(): void {
        if (!this.isDisabled() && this.props.onDayClick) {
            this.props.onDayClick(this.props.day);
        }
    }

    private isSameDay(other: Date): boolean {
        return isSameDay(this.props.day, other);
    }

    private isDisabled(): boolean {
        return isDayDisabled(
            this.props.day,
            this.props.minDate,
            this.props.maxDate,
            this.props.excludeDates,
            this.props.filterDate
        );
    }

    private isInRange(): boolean {
        const day = this.props.day;
        const startDate = this.props.startDate;
        const endDate = this.props.endDate;
        if (!startDate || !endDate) {
            return false;
        }

        return startDate.getTime() <= day.getTime() && day.getTime() <= endDate.getTime();
    }

    private isWeekend(): boolean {
        const weekday = this.props.day.getDay();
        return weekday === 0 || weekday === 6;
    }

    private isOutsideMonth(): boolean {
        return this.props.month !== undefined && this.props.month !== this.props.day.getMonth();
    }

    private getClassNames(): string {
        return classNames("cell-day", {
            "day-disabled": this.isDisabled(),
            "day-selected": this.isSameDay(this.props.selected),
            "day-in-range": this.isInRange(),
            "day-today": this.isSameDay(new Date()),
            "day-weekend": this.isWeekend(),
            "day-outside-month": this.isOutsideMonth(),
        } as any);
    }
}
